export const StakeHolder = () => {
    return <div>StakeHolder Component</div>;
};